import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { GetItemByGrp } from "../../../APIServices/SalesService/OrderService/OrderThunk";
import { convertCase, getImagePath, mapDeliveryType, validateInteger, validateSalesInteger } from "../../../SharedFiles/Helper/utils";
import { BiArrowBack } from "react-icons/bi";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { RemoveCircleOutline } from "@mui/icons-material";
import { showDeleteConfirmation } from "../../../SharedFiles/WarningMessage/deleteWarning";
import ItemData from "./itemdata";

const Itempage = React.memo(({ removeFromCart,openModal, cartItems }) => {
    const dispatch = useDispatch();
    const apiData = sessionStorage.getItem('itemGroup');
    const apiParse = JSON.parse(apiData);
    const {
        ItemByGrp,
        error,
        loading } = useSelector((state) => state.order);

    useEffect(() => {
        if (!ItemByGrp) {
            const mappedDeliveryType = mapDeliveryType(apiParse?.groupedSizes);
            dispatch(GetItemByGrp({ ItemSize: apiParse?.size, Delivery: mappedDeliveryType }))
        }
    }, [ItemByGrp]);

    return (
        <div className="itemPageMain">
            <div className="SalesBackDiv">
                {/* <button className="SalesBackButton">
                    <BiArrowBack onClick={handleBackItemGrp} size={24} />
                    {/* <i className="pi pi-delete-left backicon" onClick={handleBackItemGrp}></i> 
                </button> */}
                <p className="itemheader item">{!loading.ItemByGrp && ItemByGrp && convertCase(ItemByGrp[0].deliverY_TYPE)}</p>
            </div>
            <ItemData
                itemData={ItemByGrp}
                cartItems={cartItems}
                openModal={openModal}
                removeFromCart={removeFromCart}
            />
            {/* <ul className="lineborder itempageLine">
                {ItemByGrp?.length > 0 ? (
                    ItemByGrp.map((data, index) => {
                        // Check if the item is already in the cart
                        const existingItemIndex = cartItems.findIndex(cartItem => cartItem.item_Code === data.item_Code);

                        return (
                            <div key={index} className="lineDiv lineDivItem">

                                {existingItemIndex === -1 ? (
                                    <span className="image-div">
                                        <img
                                            src={getImagePath(data.deliverY_TYPE)}
                                            alt={data.deliverY_TYPE}
                                            className="group-image"
                                        />
                                    </span>) : (
                                    <div className="removeicon" onClick={() => removeFromCart(data.item_Code)}>
                                        <RemoveCircleOutline />
                                    </div>)}

                                <li className="groupSize align-items-center">
                                    <div className="itmlist">
                                        <p className="itemcode item">{data.item_Name}</p>
                                        <span className="itemname item">{data.height.toFixed(2)} mm</span>
                                        <p className="itemcode item">{data.item_Code}</p>
                                    </div>

                                  
                                    {existingItemIndex === -1 ? (
                                        <button className="AddCart" onClick={() => openModal(data)}>
                                            <p className="item">Add <i className="pi pi-plus"></i> </p>
                                        </button>
                                    ) : (
                                        <div className="quantityDisplay AddCart" onClick={() => openModal(data)}>
                                            <p className="item">{cartItems[existingItemIndex].quantity}</p>
                                        </div>
                                    )}
                                </li>
                            </div>
                        );
                    })
                ) : (
                    <p>There is no data found.</p>
                )}
            </ul> */}
        </div>
    );
});

export default Itempage;